document.addEventListener('DOMContentLoaded', function() {
    var key = 'ELK'; /* This is super specific for what we're doing here so we're just hard coding it here */

    $('[data-largest-shareholders-block]').each(function () {
        var targetContainer = $(this);

        $.ajax({
            url: '/api/shareholders/largest?key=' + key,
            success: function (response) {
                var responseData = JSON.parse(response);
                renderLargestShareholders(responseData, targetContainer);
            }
        });
    });

    function formatNumberWithSpaces(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function renderLargestShareholders(model, targetContainer) {
        var data = model.rows;
        var unmappedShareholderRankings = data.slice(0, -1);
        var totalShares = data.slice(-1).pop().values.TOTAL_NUMBER_OF_SHARES;
        var unrankedPercentage = 100;
        var unrankedShareCount = parseInt(totalShares);
        var rankNumber = 1;

        var templateModel = {
            shareholderRankings: unmappedShareholderRankings.map(function (rank) {
                var shares = parseInt(rank.values.TOP_POSITION_SHARES_);
                var percentage = (rank.values.TOP_POSITION_SHARES_ / totalShares * 100).toFixed(2);
                var investorName = rank.values.TOP_INVESTOR_;

                var mappedRanking = {
                    rankNumber: rankNumber,
                    investorName: investorName,
                    shares: formatNumberWithSpaces(shares),
                    percentage: percentage,
                    type: rank.values.TOP_INVESTOR_ACCOUNT_TYPE_,
                    country: rank.values.TOP_INVESTOR_COUNTRY_
                };

                unrankedPercentage -= percentage;
                unrankedShareCount -= shares;
                rankNumber++;

                return mappedRanking;
            })
        };

        var template = $('[data-largest-shareholders-table-template]').html();
        var renderedTable = Mustache.render(template, templateModel);

        $(targetContainer).append(renderedTable);

        /* If you ever want to show 'others', these are the numbers */
        // unrankedPercentage = Math.round(unrankedPercentage * 10) / 10;
        // console.log('unrankedPercentage: ' + unrankedPercentage);
        // console.log('unrankedShareCount: ' + unrankedShareCount);
    }
    
});